import React, {useEffect} from "react";
import {Button, Col, Form, Input, Row, Select, TreeSelect} from "antd";
import {useModel} from "../../../models/index"

const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 24,
    },
};
export default function () {
    const [{brandDict, engineTypeDict, materialSortDict,},] = useModel("cmDict");

    const [form] = Form.useForm();
    const [{searchParam, stockPage}, {loadStockList, setSearchParam, resetSearchParam}] = useModel("stockStatistic");

    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, [searchParam])

    const onFinish = () => {
        const {pageNum, pageSize} = stockPage
        const data = {...searchParam, pageNum: 1, pageSize};
        loadStockList({showMsg: true, data});
    }
    return (
        <Form
            form={form}
            name="stock_statistic_search"
            labelCol={{span: 6}}
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >

            <Row>
                <Col span={6}>
                    <Form.Item
                        name="materialCode"
                        label="商品编号"
                    >
                        <Input placeholder="商品编号"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="materialName"
                        label="商品名称"
                    >
                        <Input placeholder="商品名称"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="shelfCode"
                        label="货位"
                    >
                        <Input placeholder="货位"/>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name="replaceNum"
                        label="图号"
                    >
                        <Input placeholder="图号"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={6}>
                    <Form.Item
                        style={{marginBottom: 0}}
                        name="materialBrand"
                        label="品牌"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择品牌"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={brandDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        style={{marginBottom: 0}}
                        name="engineType"
                        label="发动机型号"
                    >
                        <Select
                            showSearch
                            allowClear={true}
                            placeholder="选择发动机型号"
                            filterOption={(input, option) => option.label.indexOf(input) >= 0}
                            options={engineTypeDict}
                        />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        style={{marginBottom: 0}}
                        name="category"
                        label="商品类型"
                    >
                        <TreeSelect
                            showSearch
                            allowClear
                            dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                            placeholder="请选择商品类型"
                            treeDefaultExpandAll
                            onChange={() => {
                            }}
                            treeData={materialSortDict}
                        />
                    </Form.Item>
                </Col>
                <Col
                    span={6}
                >
                    <Form.Item
                        shouldUpdate={true}
                        style={{marginBottom: 0}}
                        {...tailLayout}
                    >
                        <Button type="primary" htmlType="submit">
                            查询
                        </Button>
                        <Button
                            style={{
                                margin: '0 8px',
                            }}
                            onClick={() => {
                                form.resetFields();
                                resetSearchParam();
                                loadStockList({showMsg: true, data: {pageSize: 15, pageNum: 1}});
                            }}
                        >
                            重置
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}